import React, { useState } from "react"
import CustomButton from "../../../UI/CustomButton/CustomButton"
import classes from "./DaySection.module.css"
import { AiOutlineMinus } from "react-icons/ai"
import { useFieldArray } from "react-hook-form"
import { useEffect } from "react"
import StageSection from "../StageSection/StageSection"
import { IconButton } from "@mui/material"
import { MdArrowForwardIos } from "react-icons/md";
import { Collapse } from "@mui/material"
import Field from "../../../UI/Field/Field"

const DaySection = (props) => {
    const { index, control, onRemove, residents } = props

    const [expanded, setExpanded] = useState(false)

    const handleExpandClick = () => {
        setExpanded(!expanded)
    }

    const { fields, remove, append } = useFieldArray({
        control,
        name: `lineup.${index}.stages`
    })

    const addStage = () => {
        append({ name: "", slots: "" })
    }

    const removeStage = (idx) => {
        if (fields.length > 1) {
            remove(idx)
        }
    }

    useEffect(() => {
        if (fields.length < 1) {
            addStage()
        }
    }, [])

    return (
        <div className={classes.main}>
            <div className={classes.header}>
                <div className={classes.left}>
                    <h4>Day {index + 1}</h4>
                    <IconButton className={expanded ? classes.expanded : ""} onClick={handleExpandClick}>
                        <MdArrowForwardIos/>
                    </IconButton>
                </div>
                <CustomButton
                    className={classes.removeBut}
                    onClick={() => onRemove(index)}
                >
                    <AiOutlineMinus />
                    <span>Remove</span>
                </CustomButton>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Field direction="column">
                    {fields.map((el, idx) => (
                        <StageSection
                            key={idx}
                            el={el}
                            index={index}
                            innerIndex={idx}
                            control={control}
                            onRemove={removeStage}
                            residents={residents}
                        />
                    ))}
                    <CustomButton onClick={addStage}>Add Stage</CustomButton>
                </Field>
            </Collapse>
        </div>
    )
}

export default DaySection
